module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-row"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f2332a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseFormRow.vue
// module id = 115
// module chunks = 0